import React, { Component } from "react";
import { Button, message, Switch } from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import { hasAuth } from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import { NHConfirm } from '../../common/NHModal';
import css from './index.css';
import NHContainerFrame from '../../common/NHContainerFrame';
import AddOrEditForm from "./AddOrEditForm";
import fengjing from '../../../styles/images/fengjing.png';
import jiaotong from '../../../styles/images/jiaotong.png';
import map from '../../../styles/images/map.png';
import tongzhi from '../../../styles/images/tongzhi.png';

const basicUrl = '/fwwgl/sylj/';

/**
 * 迎新系统-服务网管理-首页链接
 */
class IndexComponet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},            //初始化表单信息
            frameVisibleMap: {
                tableFlag: true,         //列表Tab显示标志
                addFlag: false,          //新增Tab显示标志
                updateFlag: false,       //修改Tab显示标志
                showOperationBtn: false, //按钮显示标志
            },
            formFlag: '',
            updatePkid: '',              //修改信息时，对应数据的pkid
            tyzt: '',                    //停用状态
            qyzt: ''                    //启用状态
        };
    }

    componentDidMount() {
        NHFetch("/proData/selectDataList", "GET", { sign: 'dmk_xtgl_zt' })
            .then(resData => {
                if (resData.data != null) {
                    if (resData.data[0] != null && resData.data[1] != null && resData.data[0].VALUE === '1' && resData.data[1].VALUE === '0') {
                        this.setState({ tyzt: resData.data[1].LABEL, qyzt: resData.data[0].LABEL });
                    }
                }
            })
    }

    //设置当前显示页面
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            frameVisibleMap[name] = name === showFlagName;
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    };

    //新增提交
    handleAddSubmit = () => {
        const form = this.form;
        form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            const { zt, flbz, ljlx } = formData;
            formData.zt = zt ? '1' : '0';

            //完整链接
            if (ljlx === '2') {
                formData.flbz = '';
            } else {
                formData.ljdz = '';
                if (formData.flbz.length <= 0) {
                    message.warning("请选择信息发布分类！");
                    return;
                }
                formData.flbz = (flbz && flbz.length > 0) ? flbz[flbz.length - 1] : '';
            }
            NHFetch(basicUrl + "insert", "POST", formData)
                .then(resData => {
                    if (resData.data) {
                        message.success("新增成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    };

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        if (record) {
            let pkid = record.PKID;
            this.setState({
                formFlag:'edit',
                updatePkid: pkid,
                formInitData: {
                    pkid: record.PKID,
                    ljmc: record.LJMC,
                    ljdz: record.LJDZ,
                    ljtp: record.LJTP,
                    pxh: record.PXH,
                    zt: record.ZT,
                    ljlx: record.LJLX,
                    flbz: record.FLBZ
                }
            },this.setCurrentPageShow("updateFlag"));
        }
    };

    //修改提交
    handleUpdateSubmit = () => {
        const form = this.form;
        let nhTable = this.refs.nhTable;
        form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            formData.pkid = this.state.updatePkid;
            const { zt, flbz, ljlx } = formData;
            formData.zt = zt ? '1' : '0';

            //完整链接
            if (ljlx === '2') {
                formData.flbz = '';
            } else {
                formData.ljdz = '';
                if (formData.flbz.length <= 0) {
                    message.warning("请选择信息发布分类！");
                    return;
                }
                formData.flbz = (flbz && flbz.length > 0) ? flbz[flbz.length - 1] : '';
            }

            NHFetch(basicUrl + "update", "POST", formData)
                .then(resData => {
                    if (resData.data) {
                        message.success("修改成功！");
                        this.setState({ formInitData: {} });
                        this.setCurrentPageShow("tableFlag");
                        nhTable.filterTableData();
                    } else {
                        message.error("修改失败！");
                    }
                })
        });
    };

    //关闭编辑页面时
    handleFrameClose = () => {
        this.setState({
            formFlag: '', 
            formInitData: {}, 
            updatePkid: ''
        }, this.setCurrentPageShow('tableFlag'));
        this.refs.nhTable.filterTableData();
    };

    //编辑页面确认时
    handleFrameOk = () => {
        if (this.state.formFlag === "add") {
            this.handleAddSubmit();
        } else if (this.state.formFlag === "edit"){
            this.handleUpdateSubmit();
        }
        this.setState({formFlag:''});
    };

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setState({ formFlag: 'add' }, this.setCurrentPageShow('addFlag'))
    };

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    };

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    };

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    if (res.data) {
                        message.success("删除操作成功！");
                        this.setState({ showOperationBtn: false });
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    };

    // table选择row后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        this.setState({
            showOperationBtn: selectedRowKeys.length ? true : false
        });
    };

    //单行启用禁用
    updateState = (record) => {
        let PKID = record.PKID;
        NHFetch(basicUrl + "updateState", "POST", { "pkid": PKID })
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                } else {
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    };

    saveFormRef = (form) => {
        this.form = form;
    };

    buildSyljImg = (ljtp) => {
        switch (ljtp) {
            case 'fengjing.png':
                return fengjing;
            case 'jiaotong.png':
                return jiaotong;
            case 'map.png':
                return map;
            case 'tongzhi.png':
                return tongzhi;
            default:
                return '';
        }
    };

    render() {
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '链接名称',
                width: '150px',
                dataIndex: 'LJMC',
                search: 'input',
                searchType:"input"
            }, {
                title: '链接地址',
                width: '180px',
                dataIndex: 'ljdz',
                search: 'input',
                commonSearch:false,
                searchType:"input"
            }, {
                title: '链接图片',
                width: '200px',
                dataIndex: 'LJTP',
                commonSearch: false,
                sorted: false,
                render: (text, record, index) => {
                    return <img style={{ maxWidth: 40, maxHeight: 40 }} src={this.buildSyljImg(record.LJTP)} />
                }
            },
            {
                title: '状态',
                width: '150px',
                dataIndex: 'ZT',
                commonSearch: false,
                sorted: false,
                render: (text, record, index) => {
                    const status = record.ZT === '1';
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_syljgl:updateState') ?
                            <Switch checkedChildren={this.state.qyzt} unCheckedChildren={this.state.tyzt}
                                checked={status}
                                onChange={() => this.updateState(record)} /> :
                            <span>{status ? this.state.qyzt : this.state.tyzt}</span>
                    );
                },
                searchType:"select"
            },
            {
                title: '链接类型',
                width: '150px',
                dataIndex: 'LJLXMC',
                commonSearch: false,
                searchType:"input"
            },
            {
                title: '信息发布分类标志',
                width: '150px',
                dataIndex: 'FLBT',
                commonSearch: false,
                searchType:"input"
            }
        ];

        //行内操作
        const action = [
            { title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_fwwgl_syljgl:button_update' },
            { title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_fwwgl_syljgl:button_delete' }
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable ref="nhTable"
                        rowKey={record => record.PKID}
                        sign={'zhxg_yxxt_fwwgl_sylj_queryPage'}
                        columns={columns}
                        action={action}
                        rowSelectionChange={this.rowSelectionChange}>
                        {hasAuth("zhxg_yxgl_fwwgl_syljgl:button_add") &&
                            <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>}
                        {(this.state.showOperationBtn && hasAuth("zhxg_yxgl_fwwgl_syljgl:button_delete")) &&
                            <Button type="danger" ghost style={{ marginLeft: 10 }}
                                onClick={this.handleMultiDeleteBtnClick}>删除</Button>}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                    title="新增首页链接"
                    visible={this.state.frameVisibleMap.addFlag}
                    contentWidth={24}
                    onOk={this.handleFrameOk}
                    onCancel={this.handleFrameClose}>
                    <AddOrEditForm ref={this.saveFormRef} initData={this.state.formInitData} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                    title="修改首页链接"
                    visible={this.state.frameVisibleMap.updateFlag}
                    contentWidth={24}
                    onOk={this.handleFrameOk}
                    onCancel={this.handleFrameClose}>
                    <AddOrEditForm ref={this.saveFormRef} initData={this.state.formInitData} />
                </NHContainerFrame>
            </div>
        );
    }
}

export default IndexComponet;



// WEBPACK FOOTER //
// ./components/fwwgl/sylj/index.js